<template>
  <div
    :class="{
      uploader: true,
      uploading: dragging
    }"
    @dragenter="onDragEnter"
    @dragover="onDragOver"
    @dragend="onDragEnd"
    @drop="onDrop"
    @dragleave="onDragLeave"
  >
    <div class="overlay" v-if="dragging">
      <span class="overlay__text">Drop to Upload</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dragging: false,
      uploading: false
    };
  },
  props: {
    enabled: {
      required: true,
      default: true,
      type: Boolean
    }
  },
  methods: {
    onDragOver(e) {
      if (this.enabled) {
        e.preventDefault();
      }
    },
    onDragEnter(e) {
      if (this.enabled) {
        this.dragging = true;
        e.preventDefault();
      }
    },
    onDragEnd(e) {
      if (this.enabled) {
        this.dragging = false;
        e.preventDefault();
      }
    },
    onDragLeave(e) {
      if (
        !e.target.className.includes('overlay__text') &&
        !e.target.className.includes('sfdocs__navigator') &&
        !e.target.className.includes('uploader')
      ) {
        this.dragging = false;
      }
      e.preventDefault();
    },
    onDrop(e) {
      if (this.enabled) {
        e.preventDefault();

        this.dragging = false;
        this.uploading = true;

        this.$emit('file-added', e.dataTransfer);
      }
    }
  },
  mounted() {}
};
</script>

<style lang="scss">
.uploader {
  min-height: 200px;
  width: 100vw;
  position: relative;
}

.uploading {
  border-style: dashed;
  border-width: 1px;
  border-color: #54ab9d;
  border-width: 2px;
}

.overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  background-color: rgba(119, 119, 119, 0.6);
  text-align: center;
  vertical-align: middle;
  display: flex;
}

.overlay__text {
  flex: 1;
  align-self: center;
}
</style>
